module.exports = __webpack_public_path__ + "img/icon-confirm-update.0b40eca0.svg";